export const NAME = "offerRequests"
export const FIREBASE_PATH_OFFER_REQUESTS = "offerRequests"
